import { FormSection } from '@ksyos/design-system';
import { useEffect } from 'react';
import type { TreatmentData } from '@common/validation/customControls/osas/osasAllTreatmentsSchemas/types';
import type { OsasFollowUpConsultCustomControlData } from '@common/validation/customControls/osas/osasFollowUpConsultSchema';
import type { ValidationErrors } from '@frontend/utils';
import { TherapielandProgrammesEdit } from '@frontend/components/pages/episodeCategory/therapielandProgrammes/TherapielandProgrammesEdit';
import { BooleanRadioGroupFormGroup } from '../../../processActivityFormGroupFields';
import { HasChosenTreatmentFields } from '../../osasConsult/components/policyFormSection/HasChosenTreatmentFields';
import { TreatmentFormSection } from '../../osasConsult/components/treatmentFormSection/TreatmentFormSection';
import { osasYesChosenTreatmentInitialData } from '../../osasConsult/osasConsultData';

type PolicyFormSectionProps = {
    data: OsasFollowUpConsultCustomControlData;
    errors: ValidationErrors;
    onChange: (
        data: Partial<OsasFollowUpConsultCustomControlData>,
        validateKeys?: string | string[] | undefined
    ) => void;
    onChangeTreatment: (data?: Partial<TreatmentData>) => void;
};

export function PolicyFormSection(props: Readonly<PolicyFormSectionProps>) {
    const { data, errors, onChange, onChangeTreatment } = props;

    useEffect(() => {
        if (data.hasTreatment !== true) {
            onChange(
                {
                    ...osasYesChosenTreatmentInitialData,
                },
                [
                    'cpapSetting',
                    'cpapSettingText',
                    'remarkTreatment',
                    'resendQuestionnaires',
                    'resendQuestionnairesWeeks',
                    'shouldHaveFollowUpConsult',
                    'shouldHaveFollowingExamination',
                    'taskFollowingExaminationOrConsultWeeks',
                    'treatment',
                    'treatmentFollowUp',
                ]
            );
        }
    }, [data.hasTreatment]);

    return (
        <FormSection title="Nieuwe therapie starten">
            <BooleanRadioGroupFormGroup
                fieldKey="hasTreatment"
                isRequired={true}
                label="Nieuwe therapie starten"
                type="radio"
                value={data.hasTreatment}
            />

            {data.hasTreatment === true && (
                <TreatmentFormSection
                    data={data}
                    errors={errors}
                    onChange={(updatedData, validateKeys) => {
                        onChangeTreatment(updatedData.treatment);
                        onChange(updatedData, validateKeys);
                    }}
                />
            )}

            <TherapielandProgrammesEdit
                checkedTreatments={data.checkedTreatments}
                errors={errors}
                onChange={onChange}
            />

            {data.hasTreatment === true && <HasChosenTreatmentFields {...props} />}
        </FormSection>
    );
}
